import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchUserPurchases } from "../../processes/purchaseProcesses";
import { fetchInvoices } from "../../processes/invoicesProcesses";
import {
  getUserPurchases,
  getUserPurchasesLoading,
  getUserPurchasesPagination,
} from "../../selectors/purchaseSelectors";
import { getCurrentUser, getCurrentUserId } from "../../selectors/userSelectors";
import FinancePurchasesList from "./FinancePurchasesList";

function FinancePurchasesContainer(props) {
  const { dispatch, currentUserId } = props;
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (currentUserId) {
      fetchUserPurchases(dispatch, { userId: currentUserId, page });
    }
  }, [dispatch, currentUserId, page]);

  useEffect(() => {
    fetchInvoices(dispatch);
  }, [dispatch]);

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  return <FinancePurchasesList {...props} page={page} onPageChange={handlePageChange} />;
}

function mapStateToProps(state) {
  return {
    purchases: getUserPurchases(state),
    loading: getUserPurchasesLoading(state),
    pagination: getUserPurchasesPagination(state),
    invoices: state.invoicesList.invoices || [],
    currentUser: getCurrentUser(state),
    currentUserId: getCurrentUserId(state),
  };
}

export default connect(mapStateToProps)(FinancePurchasesContainer);
